import { env } from "@/api/env"
import type { Config } from "@/api/generated/model"

export interface SignInProviders {
  turnstileSiteKey?: string
  googleClientId?: string
}

/**
 * Turnstile whenever the deployment sets `VITE_TURNSTILE_SITE_KEY`, in any
 * mode: the backend checks a Turnstile token on login in every production
 * deployment, standalone included (controller ruling, DW-75). Google sign-in
 * in normal mode only, with `VITE_GOOGLE_CLIENT_ID` set (the backend refuses
 * it in standalone). Development and `pnpm dev:mock` set neither (DW-65).
 */
export function signInProviders(mode: Config["mode"]): SignInProviders {
  return {
    ...(env.VITE_TURNSTILE_SITE_KEY !== undefined && {
      turnstileSiteKey: env.VITE_TURNSTILE_SITE_KEY,
    }),
    ...(mode === "normal" &&
      env.VITE_GOOGLE_CLIENT_ID !== undefined && { googleClientId: env.VITE_GOOGLE_CLIENT_ID }),
  }
}
